export const BasicInformationformSchema = {
    npi: {
        type: 'text',
        label: 'NPI',
        placeholder: '10-digit NPI number',
        validation: {
            maxLength: 10,
        },
    },
    serviceLocationSuffix: {
        type: 'text',
        label: 'Service Location Suffix',
        placeholder: 'e.g. 0002',
    },
    contactName: {
        type: 'text',
        label: 'Contact Name',
        placeholder: 'Full name of primary contact',
    },
    contactPhone: {
        type: 'text',
        label: 'Contact Phone',
        placeholder: 'e.g. 1234567890',
    },
    taxId: {
        type: 'text',
        label: 'Tax ID',
        placeholder: '',
    },
    address: {
        type: 'text',
        label: 'Address',
        placeholder: 'e.g. 123 MAIN ST',
    },
    city: {
        type: 'text',
        label: 'City',
        placeholder: 'e.g. PHILADELPHIA',
    },
    zip: {
        type: 'text',
        label: 'ZIP Code',
        placeholder: 'e.g. 19104',
    },
};
